<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <!-- <a-col :span="5">
                <a-button type="primary" @click="tableAdd">创建校区</a-button>
            </a-col> -->
      <a-col>
        <a-form layout="inline">
          <a-form-item>
            <a-select v-model="searchFrom.suggest_type" placeholder="类型" style="width: 120px;">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="0">软件问题</a-select-option>
              <a-select-option value="1">优化建议</a-select-option>
              <a-select-option value="2">其他</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" icon="search" @click="searchbtn"></a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
      <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
        @change="onPaginationChange" bordered>
        <a-table-column key="username" title="姓名" data-index="username" />
        <a-table-column key="mobile" title="手机号码" data-index="mobile" />
        <a-table-column key="create_time" title="反馈时间" data-index="create_time" />
        <a-table-column key="showinfo" title="查看">
          <template slot-scope="item">
            <a @click="showDetail(item)">查看</a>
          </template>
        </a-table-column>
        <!--<a-table-column key="state" title="状态">-->
        <!--<template slot-scope="item">-->
        <!--<span v-if="item.state==1">已查看</span>-->
        <!--<span v-if="item.state==0">未查看</span>-->
        <!--</template>-->
        <!--</a-table-column>-->
        <!--<a-table-column key="active" title="操作">-->
        <!--<template slot-scope="item">-->
        <!--<a-button-->
        <!--v-if="item.state==0"-->
        <!--@click="changeStatus({id:item.id,state:1})"-->
        <!--class="active_btn"-->
        <!--size="small"-->
        <!--type="link"-->
        <!--&gt;启用-->
        <!--</a-button>-->
        <!--<a-button-->
        <!--v-if="item.state==1"-->
        <!--@click="changeStatus({id:item.id,state:0})"-->
        <!--class="active_btn"-->
        <!--size="small"-->
        <!--type="link"-->
        <!--&gt;禁用-->
        <!--</a-button>-->
        <!--</template>-->
        <!--</a-table-column>-->
      </a-table>
    </div>
    <a-modal :visible="showSuggestVisible" title="反馈" @ok="showSuggestVisible = false" @cancel="showSuggestVisible = false">
      <div v-if="detailForm">
        <p>名字：{{ detailForm.username }}</p>
        <p>电话：{{ detailForm.mobile }}</p>
        <p>内容：{{ detailForm.suggest_content }}</p>
        <p>设备: 厂商-{{ detailForm.device_info.brand }} 系统-{{ detailForm.device_info.platform }}
          版本-{{ detailForm.device_info.system }} 型号-{{ detailForm.device_info.model }}
          app版本-{{ detailForm.device_info.version }}</p>
        <img preview-text="反馈图片" style="max-width: 300px;max-height: 400px"
          v-if="detailForm.media_path != '' && detailForm.media_type == 1" :src="detailForm.media_path" />
        <video v-if="detailForm.media_type == 2" :src="detailForm.media_path" controls />
      </div>
    </a-modal>
  </or-layout>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      keywords: "",
      data: [],
      pageinfo: { total: 1, current: 1, pageSize: 10, allCnt: 0 },
      loading: false,
      visible: false,
      searchFrom: { suggest_type: undefined },
      showSuggestVisible: false,
      detailForm: undefined,
      campusList: [],
      campusSquadList: []
    };
  },
  mounted() {
    this.searchbtn();
  },
  methods: {
    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.getSuggestList({ keyword: this.keywords });
    },
    searchbtn() {
      this.pageinfo.current = 1;
      this.getSuggestList();
    },

    showDetail(item) {
      if (item.media_path.indexOf('.jpg') > -1) {
        item.media_type = 1;
      }
      if (item.media_path.indexOf('.mp4') > -1) {
        item.media_type = 2;
      }
      this.detailForm = item;
      this.showSuggestVisible = true;
    },
    getSuggestList() {
      this.$axios
        .post("/api/suggest/get_suggest_list", {
          data: this.searchFrom,
          pageinfo: this.pageinfo
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.data = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    moment
  }
};
</script>
<style>
.active_btn {
  margin-left: 5px;
}
</style>